import { Link } from "gatsby"
import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import {
  cardWrapper,
  cardImage,
  cardTitle,
  cardLink,
  cardArrow,
  primary,
  secondary,
  tertiary,
} from "./entry-card.module.css"
import { trackEvent } from "../../modules/analytics"
import { MdChevronRight } from "react-icons/md"

const EntryCard = ({
  title,
  link,
  image,
  imageUrl,
  variant = "primary",
  arrow = true,
  ...props
}) => {
  if (image && imageUrl)
    throw new Error(
      `Provide either 'image' or 'imageUrl', not both, in EntryCard.`
    )

  if (!link) {
    return null
  }

  const getVariantClass = () => {
    switch (variant) {
      case "primary":
        return primary
      case "secondary":
        return secondary
      case "tertiary":
        return tertiary
      default:
        return primary
    }
  }

  const articleComponent = (<article
    className={`${cardWrapper} ${getVariantClass()}`}
    {...props}
  >
    {image && (
      <GatsbyImage
        className={cardImage}
        alt={image.title ? image.title : ""}
        image={image.gatsbyImageData}
      />
    )}
    {imageUrl && <img src={imageUrl} alt={title} width={70} />}

    <h3 className={cardTitle}>{title}</h3>
    {arrow && <div className={cardArrow}>
      <MdChevronRight size={40} />
    </div>
    }
  </article>)

  if (link.startsWith("https://")) {
    return (
      <a href={link} title={title} className={cardLink} target="_blank" onClick={() => {
        trackEvent(`cta_entry_card_external`, { link_url: link })
      }}>
        {articleComponent}
      </a>
    )
  }

  return (
    <Link to={link} title={title} className={cardLink} onClick={() => {
      trackEvent(`cta_entry_card_internal`, { link_url: link })
    }}>
      {articleComponent}
    </Link>
  )
}

export default EntryCard
